import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
declare const SpeechSDK: any;

@Injectable({
  providedIn: 'root'
})
export class SpeechRecognitionService {
  private _recognizer;
  private _speechConfig;
  private _audioConfig;
  private readonly speechRecognitionLanguage = 'en-US';

  constructor( 
    private readonly httpClient: HttpClient
  ) { }

  initRecognition(deviceId: string, speechKey: string) {
    this._audioConfig = SpeechSDK.AudioConfig.fromMicrophoneInput(deviceId);

    this._speechConfig = SpeechSDK.SpeechConfig.fromSubscription(speechKey, "eastus");
    this._speechConfig.speechRecognitionLanguage = this.speechRecognitionLanguage;
    this._recognizer = new SpeechSDK.SpeechRecognizer(this._speechConfig, this._audioConfig);

    this._recognizer.recognized = (s, e) => this.handleRecognizedResponse(e);
    this._recognizer.canceled = (s, e) => this.handleCanceled(e);
  }

  startContinuousRecognition() {
    this._recognizer.startContinuousRecognitionAsync();
  }

  stopRecognition() {
    this._recognizer.stopContinuousRecognitionAsync(() => {
      this._recognizer.close();
    });
  }

  private handleRecognizedResponse(e) {
    if (e.result.text) {
      this.verbiageCapture(e.result.text).subscribe();
    }
  }

  private handleCanceled(e) {
  }

  verbiageCapture(text: string) {
    return this.httpClient.post('verbiageCapture', {
      verbiageText: text
    }, { responseType: 'text' });
  }

  getSpeechKey() {
    return this.httpClient.get('verbiageCapture/speechKey', { responseType: 'text' });
  }
}
